import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Heading } from '../components/blocks/Heading';
import { HeadlineElement, TitleElement, SubtitleElement } from '../types';
import { isHeadline } from './isHeadline';
import { isSubtitle } from './isSubtitle';
import { isTitle } from './isTitle';

/**
 * Check if the given node is a heading
 */
export const isHeading = (node: any): node is HeadlineElement | TitleElement | SubtitleElement => {
    return isHeadline(node) || isTitle(node) || isSubtitle(node) || isElementType(Heading)(node);
};
